// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as GPayLazy$OrcaPaymentPage from "./GPayLazy.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as Surcharge$OrcaPaymentPage from "../Components/Surcharge.bs.js";
import * as PayPalLazy$OrcaPaymentPage from "./PayPalLazy.bs.js";
import * as PazeButton$OrcaPaymentPage from "./PazeButton.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as ApplePayLazy$OrcaPaymentPage from "./ApplePayLazy.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "../hyper-log-catcher/ErrorBoundary.bs.js";
import * as KlarnaHelpers$OrcaPaymentPage from "./KlarnaHelpers.bs.js";
import * as KlarnaSDKLazy$OrcaPaymentPage from "./KlarnaSDKLazy.bs.js";
import * as PayPalHelpers$OrcaPaymentPage from "./PayPalHelpers.bs.js";
import * as PaypalSDKLazy$OrcaPaymentPage from "./PaypalSDKLazy.bs.js";
import * as WalletShimmer$OrcaPaymentPage from "../Components/WalletShimmer.bs.js";
import * as KlarnaCheckoutLazy$OrcaPaymentPage from "./KlarnaCheckoutLazy.bs.js";
import * as SamsungPayComponent$OrcaPaymentPage from "./SamsungPayComponent.bs.js";
import * as ReusableReactSuspense$OrcaPaymentPage from "../hyper-log-catcher/ReusableReactSuspense.bs.js";
import * as SessionPaymentWrapper$OrcaPaymentPage from "../Components/SessionPaymentWrapper.bs.js";
import * as ThirdPartyFlowHelpers$OrcaPaymentPage from "../Hooks/ThirdPartyFlowHelpers.bs.js";
import * as CustomPaymentMethodsConfig$OrcaPaymentPage from "../Hooks/CustomPaymentMethodsConfig.bs.js";

function paymentMode(str) {
  switch (str) {
    case "apple_pay" :
    case "applepay" :
        return "ApplePayWallet";
    case "google_pay" :
    case "gpay" :
        return "GPayWallet";
    case "klarna" :
        return "KlarnaWallet";
    case "paypal" :
        return "PaypalWallet";
    case "paze" :
        return "PazeWallet";
    case "samsung_pay" :
    case "samsungpay" :
        return "SamsungPayWallet";
    default:
      return "NONE";
  }
}

function PaymentRequestButtonElement$WalletsSaveDetailsText(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areOneClickWalletsRendered);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var isGuestCustomer = UtilityHooks$OrcaPaymentPage.useIsGuestCustomer();
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var walletMessageConfig = CustomPaymentMethodsConfig$OrcaPaymentPage.useCustomPaymentMethodConfigs("wallet", undefined);
  var shouldRender = PaymentUtils$OrcaPaymentPage.isAppendingCustomerAcceptance(isGuestCustomer, paymentMethodListValue.payment_type, match$2.alwaysSendCustomerAcceptance) && (match.isGooglePay || match.isApplePay || match.isPaypal || match.isSamsungPay) && walletMessageConfig.displayMode !== "Hidden";
  var match$3 = walletMessageConfig.displayMode;
  var tmp;
  var exit = 0;
  switch (match$3) {
    case "CustomMessage" :
        var msg = Core__Option.getOr(walletMessageConfig.value, "").trim();
        tmp = React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: msg.length > 0,
              children: React.createElement("div", {
                    className: "SaveWalletDetailsLabel text-xs mt-2 text-left text-gray-400"
                  }, React.createElement("em", undefined, msg))
            });
        break;
    case "DefaultSdkMessage" :
    case "Hidden" :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp = React.createElement("div", {
          className: "SaveWalletDetailsLabel flex items-center text-xs mt-2 text-left text-gray-400"
        }, React.createElement(Icon$OrcaPaymentPage.make, {
              name: "lock",
              size: 10,
              className: "mr-1"
            }), React.createElement("em", undefined, match$1.localeString.saveWalletDetails));
  }
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: shouldRender,
              children: tmp
            });
}

var WalletsSaveDetailsText = {
  make: PaymentRequestButtonElement$WalletsSaveDetailsText
};

function PaymentRequestButtonElement(props) {
  var walletOptions = props.walletOptions;
  var dict = Utils$OrcaPaymentPage.getDictFromJson(props.sessions);
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var sessionObj = React.useMemo((function () {
          return SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
        }), [dict]);
  var trustPayScriptStatus = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.trustPayScriptStatus);
  var isApplePayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isApplePayReady);
  var isApplePayDelayedSessionFlow = ThirdPartyFlowHelpers$OrcaPaymentPage.useIsApplePayDelayedSessionFlow();
  var isGooglePayDelayedSessionFlow = ThirdPartyFlowHelpers$OrcaPaymentPage.useIsGooglePayDelayedSessionFlow();
  var setIsShowOrPayUsingWhileLoading = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isShowOrPayUsingWhileLoading);
  var match = PayPalHelpers$OrcaPaymentPage.usePaymentMethodData(paymentMethodListValue, sessionObj);
  var isPaypalRedirectFlow = match.isPaypalRedirectFlow;
  var isPaypalSDKFlow = match.isPaypalSDKFlow;
  var paypalToken = match.paypalToken;
  var gPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Gpay");
  var applePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ApplePayObject");
  var applePayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(applePaySessionObj.sessionsToken, "ApplePay");
  var samsungPaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "SamsungPayObject");
  var samsungPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(samsungPaySessionObj.sessionsToken, "SamsungPay");
  var googlePayThirdPartySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "GooglePayThirdPartyObject");
  var googlePayThirdPartyToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(googlePayThirdPartySessionObj.sessionsToken, "Gpay");
  React.useEffect((function () {
          var isTrustPayScriptLoading = trustPayScriptStatus === "Loading";
          var isApplePayThirdPartyLoading = isApplePayDelayedSessionFlow && isApplePayReady && isTrustPayScriptLoading;
          var isGooglePayThirdPartyLoading = isGooglePayDelayedSessionFlow && isTrustPayScriptLoading;
          if (isGooglePayThirdPartyLoading || isApplePayThirdPartyLoading) {
            setIsShowOrPayUsingWhileLoading(function (param) {
                  return true;
                });
          } else {
            setIsShowOrPayUsingWhileLoading(function (param) {
                  return false;
                });
          }
        }), [
        isGooglePayDelayedSessionFlow,
        isApplePayDelayedSessionFlow,
        isApplePayReady,
        trustPayScriptStatus
      ]);
  var match$1 = KlarnaHelpers$OrcaPaymentPage.usePaymentMethodExperience(paymentMethodListValue, sessionObj);
  var isKlarnaCheckoutFlow = match$1.isKlarnaCheckoutFlow;
  var isKlarnaSDKFlow = match$1.isKlarnaSDKFlow;
  var klarnaTokenObj = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Klarna");
  var pazeTokenObj = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Paze");
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var clientSecret = match$2.clientSecret;
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var isTestMode = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isTestMode);
  return React.createElement("div", {
              "aria-label": "Wallet Section",
              className: "flex flex-col gap-2 h-auto w-full",
              role: "region"
            }, walletOptions.map(function (item, i) {
                  var match = paymentMode(item);
                  var tmp;
                  switch (match) {
                    case "GPayWallet" :
                        var tmp$1;
                        if (gPayToken.TAG === "OtherTokenOptional") {
                          var optToken = gPayToken._0;
                          tmp$1 = googlePayThirdPartyToken.TAG === "GooglePayThirdPartyTokenOptional" ? React.createElement(GPayLazy$OrcaPaymentPage.make, {
                                  sessionObj: optToken,
                                  thirdPartySessionObj: googlePayThirdPartyToken._0,
                                  walletOptions: walletOptions
                                }) : React.createElement(GPayLazy$OrcaPaymentPage.make, {
                                  sessionObj: optToken,
                                  thirdPartySessionObj: undefined,
                                  walletOptions: walletOptions
                                });
                        } else {
                          tmp$1 = null;
                        }
                        tmp = React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
                              children: tmp$1,
                              type_: "Wallet"
                            });
                        break;
                    case "PaypalWallet" :
                        var tmp$2;
                        if (paypalToken.TAG === "OtherTokenOptional") {
                          var optToken$1 = paypalToken._0;
                          var exit = 0;
                          if (optToken$1 !== undefined && isPaypalSDKFlow) {
                            tmp$2 = React.createElement(PaypalSDKLazy$OrcaPaymentPage.make, {
                                  sessionObj: optToken$1
                                });
                          } else {
                            exit = 1;
                          }
                          if (exit === 1) {
                            tmp$2 = isPaypalRedirectFlow ? React.createElement(PayPalLazy$OrcaPaymentPage.make, {
                                    walletOptions: walletOptions
                                  }) : null;
                          }
                          
                        } else {
                          tmp$2 = React.createElement(RenderIf$OrcaPaymentPage.make, {
                                condition: isPaypalRedirectFlow,
                                children: React.createElement(PayPalLazy$OrcaPaymentPage.make, {
                                      walletOptions: walletOptions
                                    })
                              });
                        }
                        tmp = React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
                              children: tmp$2,
                              type_: "Wallet"
                            });
                        break;
                    case "ApplePayWallet" :
                        tmp = applePayToken.TAG === "ApplePayTokenOptional" ? React.createElement(ApplePayLazy$OrcaPaymentPage.make, {
                                sessionObj: applePayToken._0,
                                walletOptions: walletOptions
                              }) : null;
                        break;
                    case "KlarnaWallet" :
                        var tmp$3;
                        if (klarnaTokenObj.TAG === "OtherTokenOptional") {
                          var optToken$2 = klarnaTokenObj._0;
                          tmp$3 = optToken$2 !== undefined ? (
                              isKlarnaSDKFlow ? React.createElement(KlarnaSDKLazy$OrcaPaymentPage.make, {
                                      sessionObj: optToken$2
                                    }) : (
                                  isKlarnaCheckoutFlow ? React.createElement(KlarnaCheckoutLazy$OrcaPaymentPage.make, {}) : null
                                )
                            ) : (
                              isKlarnaCheckoutFlow ? React.createElement(KlarnaCheckoutLazy$OrcaPaymentPage.make, {}) : null
                            );
                        } else {
                          tmp$3 = null;
                        }
                        tmp = React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
                              children: tmp$3,
                              type_: "Others"
                            });
                        break;
                    case "SamsungPayWallet" :
                        tmp = samsungPayToken.TAG === "SamsungPayTokenOptional" ? React.createElement(SamsungPayComponent$OrcaPaymentPage.make, {
                                sessionObj: samsungPayToken._0,
                                walletOptions: walletOptions
                              }) : null;
                        break;
                    case "PazeWallet" :
                        var tmp$4;
                        if (pazeTokenObj.TAG === "OtherTokenOptional") {
                          var optToken$3 = pazeTokenObj._0;
                          tmp$4 = optToken$3 !== undefined ? React.createElement(PazeButton$OrcaPaymentPage.make, {
                                  token: optToken$3
                                }) : null;
                        } else {
                          tmp$4 = null;
                        }
                        tmp = React.createElement(RenderIf$OrcaPaymentPage.make, {
                              condition: options.wallets.paze === "Auto",
                              children: React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
                                    children: tmp$4,
                                    type_: "Wallet"
                                  })
                            });
                        break;
                    case "NONE" :
                        tmp = null;
                        break;
                    
                  }
                  return JsxPPXReactSupportU.createElementWithKey(item + "-" + i.toString() + "-request-button", ErrorBoundary$OrcaPaymentPage.make, {
                              children: JsxPPXReactSupportU.createElementWithKey(i.toString(), ReusableReactSuspense$OrcaPaymentPage.make, {
                                    children: React.createElement(RenderIf$OrcaPaymentPage.make, {
                                          condition: Core__Option.isSome(clientSecret) || isTestMode,
                                          children: tmp
                                        }),
                                    loaderComponent: React.createElement(WalletShimmer$OrcaPaymentPage.make, {}),
                                    componentName: "PaymentRequestButtonElement"
                                  }),
                              level: "RequestButton",
                              componentName: "PaymentRequestButtonElement"
                            });
                }), React.createElement(Surcharge$OrcaPaymentPage.make, {
                  paymentMethod: "wallet",
                  paymentMethodType: "google_pay",
                  isForWallets: true
                }), React.createElement(PaymentRequestButtonElement$WalletsSaveDetailsText, {}));
}

var make = PaymentRequestButtonElement;

export {
  paymentMode ,
  WalletsSaveDetailsText ,
  make ,
}
/* react Not a pure module */
